import { FloorplanMarker } from '../types/floorplan';

type FloorplanMarkerRatios = {
  x: number;
  y: number;
};

type FloorplanDimensions = {
  width: number;
  height: number;
};

function isFiniteNumber(value: unknown): value is number {
  return typeof value === 'number' && Number.isFinite(value);
}

function hasUsableFloorplanDimensions(
  dimensions?: Partial<FloorplanDimensions> | null,
): dimensions is FloorplanDimensions {
  return (
    isFiniteNumber(dimensions?.width) &&
    isFiniteNumber(dimensions?.height) &&
    dimensions.width > 0 &&
    dimensions.height > 0
  );
}

export function getFloorplanMarkerRatios(
  originalDimensions?: Partial<FloorplanDimensions> | null,
  currentDimensions?: Partial<FloorplanDimensions> | null,
): FloorplanMarkerRatios | null {
  if (
    !hasUsableFloorplanDimensions(originalDimensions) ||
    !hasUsableFloorplanDimensions(currentDimensions)
  ) {
    return null;
  }

  return {
    x: originalDimensions.width / currentDimensions.width,
    y: originalDimensions.height / currentDimensions.height,
  };
}

export function shouldUseFloorplanMarkerXYPosition(
  marker?: Partial<FloorplanMarker> | null,
): boolean {
  const x = marker?.x;
  const y = marker?.y;

  return isFiniteNumber(x) && isFiniteNumber(y);
}

export function getFloorplanMarkerImagePoint(
  marker?: Partial<FloorplanMarker> | null,
  ratios?: FloorplanMarkerRatios | null,
): { x: number; y: number } | null {
  const x = marker?.x;
  const y = marker?.y;

  if (
    !shouldUseFloorplanMarkerXYPosition(marker) ||
    !isFiniteNumber(x) ||
    !isFiniteNumber(y) ||
    !isFiniteNumber(ratios?.x) ||
    !isFiniteNumber(ratios?.y) ||
    ratios.x === 0 ||
    ratios.y === 0
  ) {
    return null;
  }

  return {
    x: x / ratios.x,
    y: y / ratios.y,
  };
}
